import { useState } from 'react';
import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { TaskIcon } from 'app/agriculture/icons';
import './TaskListContainer.scss';
import { TaskListHeader } from 'app/agriculture/routes/Tasks/TaskList/components/TaskListHeader/TaskListHeader';
import {
    TaskListComponent,
    TaskListGroupMode,
} from 'app/agriculture/routes/Tasks/TaskList/components/TaskListComponent';
import { useTaskResults } from 'app/agriculture/routes/Tasks/TaskList/hooks/useTaskResults';

export function TaskListContainer() {
    const [textFilter, setTextFilter] = useState('');
    const [groupMode, setGroupMode] = useState<TaskListGroupMode>('User');
    const tasks = useTaskResults(textFilter);

    return (
        <ContentBox title="Tasks" Icon={TaskIcon} variant="lg">
            <ContentBox.Section>
                <TaskListHeader
                    onTextFilterChange={setTextFilter}
                    onGroupModeChange={setGroupMode}
                />
            </ContentBox.Section>
            <ContentBox.Section scrollable>
                <TaskListComponent
                    tasks={tasks}
                    groupMode={groupMode}
                    hasFilterApplied={textFilter.length > 0}
                />
            </ContentBox.Section>
        </ContentBox>
    );
}
